import { render, staticRenderFns } from "./Transporters.vue?vue&type=template&id=3921dc37&scoped=true&"
import script from "./Transporters.vue?vue&type=script&lang=js&"
export * from "./Transporters.vue?vue&type=script&lang=js&"
import style0 from "./Transporters.vue?vue&type=style&index=0&id=3921dc37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3921dc37",
  null
  
)

export default component.exports